import hooks from './shipment-transfers.hooks';

export default (app) => {
  const service = app.service('api/shipment-transfers');

  // TODO: Remove this with feathers-dataloader update
  service.options = {
    id: 'id'
  };

  service.hooks(hooks);
};
